module.exports = __webpack_public_path__ + "media/src/images/logo_iversity_springer-c19997689441cbdf276bf4fa3ff439ec.svg";